import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as n, useEffect as e, useCallback as t, useMemo as r } from "react";
import { OrganizationTypeId as o } from "../features/organizations/types.js";
import { OrganizationManager as c } from "../utils/organizationManager.js";
const f = "CONTEXT_ORGANIZATION_ID_CACHE_KEY", g = a({ organization: void 0, changeOrganization: () => {
}, checkMainOffice: () => false, isMainOffice: false, organizationId: null }), s = () => n(g), d = (i2) => i2.typeId === o.MainOffice, O = ({ value: a2, children: n2 }) => {
  e(() => {
    c.addListener((i2) => {
      localStorage.setItem(f, i2);
    });
  }, []), e(() => {
    c.getState() !== a2.id && c.setState(a2.id);
  }, [a2.id]);
  const o2 = t((i2) => {
    location.href = `/${i2}`;
  }, []), s2 = r(() => d(a2), [a2]);
  return i(g.Provider, { value: { organization: a2, isMainOffice: s2, changeOrganization: o2, checkMainOffice: d, OrganizationManager: c, organizationId: a2 == null ? void 0 : a2.id }, children: n2 });
};
export {
  f as CONTEXT_ORGANIZATION_ID_CACHE_KEY,
  g as OrganizationContext,
  O as OrganizationProvider,
  d as checkMainOffice,
  s as useOrganizationContext
};
//# sourceMappingURL=OrganizationProvider.js.map
